import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

const HeaderSecondary = () => {
  const router = useRouter();

  return (
    <div className='flex items-center justify-between mb-8 lg:mb-10 lg:pr-8'>
      <div>
        <Link href='/'>
          <a href='/'>
            <img src='/images/logo.svg' alt='Easy Loan Logo' />
          </a>
        </Link>
      </div>
      {router.pathname === '/partners/login' ? (
        <div className='app-text-dm-small text-gray text-opacity-80 text-right'>
          Don’t have a Account?
          <Link href='/partners/signup'>
            <a href='/partners/signup'>
              <span className='app-text-link text-secondary uppercase ml-[5px]'> Signup here</span>
            </a>
          </Link>
        </div>
      ) : (
        <div className='app-text-dm-small text-gray text-opacity-80'>
          Already a User?
          <Link href='/partners/login'>
            <a href='/partners/login'>
              <span className='app-text-link text-secondary uppercase ml-[5px]'> Login here</span>
            </a>
          </Link>
        </div>
      )}
    </div>
  );
};

export default HeaderSecondary;
